import { Component, Input, OnInit } from '@angular/core';
import { RedemptionCodeSet } from '../../../../../../../../models/redemption-code';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RedemptionCodeService } from '../../../../../../../../services/redemption-code/redemption-code.service';


@Component({
  selector: 'app-rename-redemption-code-set-modal',
  templateUrl: './rename-redemption-code-set-modal.component.html',
  styleUrls: ['./rename-redemption-code-set-modal.component.css']
})
export class RenameRedemptionCodeSetModalComponent implements OnInit {
  @Input() redemptionCodeSet: RedemptionCodeSet;
  @Input() savedCallback: () => undefined;

  public name: string;

  public loadingSubmit = false;

  public errorMessage = '';
  public serverError: number = null;

  constructor(
    public activeModal: NgbActiveModal,
    private redemptionCodeService: RedemptionCodeService,
  ) {}

  ngOnInit() {
    this.name = this.redemptionCodeSet.name;
  }

  public handleSubmit() {
    this.loadingSubmit = true;

    this.redemptionCodeService
      .renameRedemptionCodeSet(
        this.redemptionCodeSet.id,
        this.name
      )
      .then(() => {
        this.savedCallback();
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to rename this redemption code set.';
        } else if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }
}
